var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotsureSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2361 22.4943C17.749 22.4943 22.2181 18.0252 22.2181 12.5123C22.2181 6.99936 17.749 2.53027 12.2361 2.53027C6.72324 2.53027 2.25415 6.99936 2.25415 12.5123C2.25415 18.0252 6.72324 22.4943 12.2361 22.4943Z",
    stroke: "white",
    strokeWidth: 1.426,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3313 9.51844C9.56598 8.85132 10.0292 8.28877 10.6389 7.93044C11.2486 7.57211 11.9654 7.44113 12.6625 7.56069C13.3595 7.68025 13.9917 8.04263 14.4471 8.58366C14.9026 9.12469 15.1519 9.80944 15.1508 10.5166C15.1508 12.513 12.1562 13.5112 12.1562 13.5112",
    stroke: "white",
    strokeWidth: 1.426,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2356 17.5029H12.2433",
    stroke: "white",
    strokeWidth: 1.426,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotsureSvg);
export default __webpack_public_path__ + "static/media/NotsureSvg.81b4fe67ae38aaeea8900343b0f2bed7.svg";
export { ForwardRef as ReactComponent };